import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { x } from '@xstyled/styled-components'

import Articles from '../components/Articles'
import { fetchArticles, fetchMoreArticles } from '../../store/articles'
import { fetchTrendingArticles } from '../../store/trendingArticles'
import { fetchTrendsList } from '../../store/trends'
import { sectionPageView, setPageType } from '../../store/app'
import { getVisitorId, getSessionId } from '../../store/article'
import { TrendsPageSkeleton , ArticleFourRowSkeleton } from '../components/Skeletons'
import WingBanners from '../components/WingBanners'
import NotFound from './NotFound'
import NoImage from '../../../assets/images/general/no-image.png'
import StyledLink from '../components/ui/Link'
import next from '../../../assets/images/icons/gallery-next.svg'

import AlphabeticList from '../components/AlphabeticList'
import ArticleFourRow from '../../templates/ArticleFourRow'
import { FORMATS, MAPPINGS } from '../components/AdFormats'
import Ad from '../components/Ad'

const ArticlesTemplate = ({ articles, section, noImage, isConnected, sectionLabel, moreButton, withReadCount, adPath, sessionId, visitorId }) => (
  <>
    <x.div position='relative' w='100%' maxWidth={{ sm: '1260px', wAdD: '1660px' }} mx='auto'>
      <x.h3 text='h4' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}>{sectionLabel}</x.h3>
      <StyledLink to={section} position='absolute' top='50%' right='0' transform='translateY(-50%)' textTransform='uppercase' text='small' color={{ hover: 'red' }} display='flex' justifyContent='center' alignItems='center' flexDirection='row'>More <x.img src={next} w='24px' h='24px' /></StyledLink>
    </x.div>
    <x.div maxWidth={{ sm: '1260px', wAdD: '1660px' }} w='100%' mx='auto' mb={50}>
      <ArticleFourRow articles={articles} section={section} noImage={noImage} moreButton={moreButton} isConnected={isConnected} withReadCount={withReadCount} adPath={adPath} sessionId={sessionId} visitorId={visitorId} />
    </x.div>
  </>
)

export class TrendsPage extends Component {
  constructor(props) {
    super(props)
    setPageType('section')
    props.sectionPageView(props.location.pathname, props.section, props.visitorId, props.sessionId, props.app.firstRender)
    if (!this.props.trends.hasFetched) {
      props.fetchTrendingArticles()
      props.fetchTrendsList()
    }
  }

  render() {
    if (this.props.hasError) {
      return (
        <p>Error: {this.props.error}</p>
      )
    }
    if (this.props.trends.hasFetched && this.props.currentTrends && this.props.currentTrends.trendingarticles.hasFetched) {
      return (
        <>
          <x.main px={{ sm: '20px', wAdD: this.props.app.wallpaperActive ? '0px' : '200px' }} mt={{ sm: '96px', lg: this.props.app.wallpaperActive ? '0px' : '173px' }} w='100%' maxWidth={{ sm: '1260px', wAdD: this.props.app.wallpaperActive ? '1220px' : '1660px' }} mx='auto'>
            <Ad isConnected={this.props.isConnected} adPath={this.props.adPath} slotId='interstitial' targeting={{ interstitial: 'interstitial' }} collapseEmptyDiv className='advert' anchor='interstitial' mapping={MAPPINGS.Interstitial} {...FORMATS.interstitial} />
            <WingBanners isConnected={this.props.isConnected} adPath={this.props.adPath} location={this.props.location} onSlotRenderEndedLeft={this.props.onSlotRenderEndedLeft} onSlotRenderEndedRight={this.props.onSlotRenderEndedRight} />
            <x.div w='100%' maxWidth={{ sm: '1260px', wAdD: '1660px' }} pb={10} my={50} mx='auto' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider'>
              <x.h1 text='h3' mr={{ sm: '0', lg: '50px' }} mb={{ sm: '10', lg: '0' }} w={{ sm: '100%', lg: 'auto' }}>Trending on IOL</x.h1>
            </x.div>
            {this.props.currentTrends.trendingarticles.sectionsLabels.map(trend => (
              <x.div key={trend.uuid}>
                <Articles
                  articles={this.props.articles} fetchArticles={this.props.fetchArticles} fetchMoreArticles={this.props.fetchMoreArticles} noDiv isConnected loading={ArticleFourRowSkeleton} section={trend.slug} count={8} pageSize={8} noImage={NoImage} notFound={NotFound} component={ArticlesTemplate}
                />
              </x.div>
            ))}
            <x.div display='flex' maxWidth={{ sm: '1260px', wAdD: '1660px' }} w='100%' mx='auto' justifyContent='space-between' mt={50}>
              <x.div borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20} w='100%'>
                <x.h2>All Trends on IOL</x.h2>
              </x.div>
            </x.div>
            <AlphabeticList arrayList={this.props.trends.trends} sessionId={this.props.sessionId} visitorId={this.props.visitorId} />
          </x.main>
        </>
      )
    } else {
      return (
        <TrendsPageSkeleton />
      )
    }
  }
}

const mapStateToProps = (state) => ({ app: state.app, articles: state.articles, trends: state.trends, currentTrends: state.trendingArticles, visitorId: getVisitorId(state), sessionId: getSessionId(state) })
const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchTrendsList, fetchArticles, fetchMoreArticles, fetchTrendingArticles, sectionPageView }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(TrendsPage)
